import * as Yup from 'yup';

import { ageSchema } from '../../../../../../utils/validation-schemas/age';

export const FormFields = {
  Name: 'name',
  Breed: 'breed',
  Age: 'age',
  Weight: 'weight',
} as const;

export const schema = Yup.object({
  [FormFields.Name]: Yup
    .string()
    .required()
    .label('Pet name'),
  [FormFields.Breed]: Yup.object()
    .shape({
      name: Yup.string(),
      value: Yup.string(),
    })
    .required()
    .default(undefined)
    .label('Breed'),
  [FormFields.Age]: ageSchema,
  [FormFields.Weight]: Yup.object()
    .shape({
      label: Yup.string(),
      value: Yup.string(),
    })
    .required()
    .default(undefined)
    .label('Weight'),
});
